import './business-unit-and-users.scss'

import styled from '@emotion/styled'
import { useState } from 'react'

import { Space, Tabs, Typography } from '../../../components/core-v2'
import Icon from '../../../components/core-v2/atoms/Icon'
import { EditBusinessUnit } from '../business-unit-details/edit-business-unit'
import { BusinessUnitUsers } from '../business-unit-users/business-unit-users'
import { ClientsState } from '../clients/clients.state'

export type Props = {
  onExistingBusinessUnitSaved: () => void
  resetSavedIndicator: () => void
  state: ClientsState
}

type TabId = 'details' | 'users'

const StyledUsersDetails = styled.div`
  height: calc(100vh - 253px);
  overflow-y: auto;
`

export function BusinessUnitDetailsAndUsers({
  onExistingBusinessUnitSaved,
  resetSavedIndicator,
  state
}: Props) {
  const [activeTabId, setActiveTabId] = useState<TabId>('details')

  return (
    <div className="business-unit-details-and-users">
      <div className="business-unit-top-block">
        <Space isflex alignItems="center">
          <Space mr={3}>
            <Typography fontSize="15px" letterSpacing="0" variant="b3">
              {state.clientName}
            </Typography>
          </Space>
          <Icon name="chevronRight" size="small" />
          <Space ml={3}>
            <Typography fontSize="15px" letterSpacing="0" variant="b3">
              {state.selectedBusinessUnit.businessUnitName}
            </Typography>
          </Space>
        </Space>
        <Tabs.List className="mt-4" showRule={false} spacing="sm">
          <Tabs.Tab
            isSelected={activeTabId === 'details'}
            value="details"
            onClick={() => {
              setActiveTabId('details')
              resetSavedIndicator()
            }}
          >
            Business unit details
          </Tabs.Tab>
          <Tabs.Tab
            isSelected={activeTabId === 'users'}
            value="users"
            onClick={() => {
              setActiveTabId('users')
              resetSavedIndicator()
            }}
          >
            Business unit users
          </Tabs.Tab>
        </Tabs.List>
      </div>
      <StyledUsersDetails>
        {activeTabId === 'details' && (
          <Tabs.Panel value="details">
            <EditBusinessUnit
              businessUnit={state.selectedBusinessUnit}
              client={state.client}
              clientId={state.clientId}
              isSaveSuccessful={state.isBusinessUnitSavedSuccessfully}
              strategies={state.strategies}
              onSaveSuccess={onExistingBusinessUnitSaved}
            />
          </Tabs.Panel>
        )}
        {activeTabId === 'users' && (
          <Tabs.Panel value="users">
            <BusinessUnitUsers businessUnitId={state.selectedBusinessUnit.businessUnitId} />
          </Tabs.Panel>
        )}
      </StyledUsersDetails>
    </div>
  )
}
